<drawer *ngIf="cost" [title]="showDeterminantBuilder ? 'Cost - Determinant' : cost.id ? 'Edit cost' : 'Add cost'"
	[showHeaderButtons]="true"
	[hideDelete]="true"
	[hideCancel]="false"
	[hideSave]="false"
	[contextLabel]="cost?.name || ('Cost ' + (cost.id ? cost.id : ''))"
	[noContentPadding]="showDeterminantBuilder"
	[isClosed]="false"
	(saveEvent)="save()"
	(cancelEvent)="closeLayer()"
	(closeEvent)="closeLayer()">
	<div class="drawer-content drawer-direct-content">
		<div *ngIf="showDeterminantBuilder" class="d-flex overflow-hidden mh-100 h-100 w-100">
			<!--
			<formula-builder-section
				*ngIf="costView && !costView.value && openFormula"
				class="row layer sub-layer px-3 pt-1 not-iframe"
				[isEmbedded]="false"
				[costView]="costView"
			></formula-builder-section>
			-->
			<!--
			<cost-determinant-section
				class="row layer sub-layer px-3 pt-1 cost-determinant-sublayer"
				[ngClass]="{'hidden': !(store.state.common.determinantSection.topLayer && isFormulaCost())}"
			></cost-determinant-section>
		-->

			<determinant-new
				*ngIf="store.state.common.determinantSection.topLayer === 'edit'"
				class="d-flex overflow-hidden mh-100 w-100 flex-column"
				[serviceId]="serviceId"
				[determinant]="store.state.common.determinantSection.determinant"
				[isEmbedded]="false"
				[isClosed]="false"
				(formSubmit)="closeDetLayer()"
				(editCancel)="closeDetLayer()"
			></determinant-new>
			<div *ngIf="!openFormula" class="overflow-hidden mh-100 h-100 w-100 {{store.state.common.determinantSection.topLayer === 'edit' ? 'd-none' : 'd-flex'}} flex-column">
				<div class="mb-0 no-gutters row h-100 overflow-hidden w-100">
					<div class="col list-determinants h-100 mh-100">
						<determinant-list
							class="d-flex overflow-hidden mh-100 h-100 flex-column flex-grow-0 py-3 pl-3"
							[groupsLength]="{value: cost.jsonDeterminants}"
							[prefix]="'ce'"
							[determinantMapById]="determinantMapById"
							[addDeterminantTo]="appendDeterminant"></determinant-list>
					</div>
					<div class="col pl-2 pb-3 query-builder">
						<query-builder [determinantMapById]="determinantMapById"
							[ngClass]="'fixed scrolleable'"
							[prefix]="'ce'"
							[jsonString]="cost.jsonDeterminants"
							(onChange)="cost.jsonDeterminants = $event.jsonString"></query-builder>
					</div>
				</div>
			</div>
		</div>
		
		<div *ngIf="!showDeterminantBuilder" class="row">
			<div class="col-12">
				<form name="itemForm" role="form">
					<div class="row fields-group mt-3">
						<div class="col-lg-8 col-md-12 mb-3 mb-lg-0">
							<label class="input-label field-required">{{ 'annexes.costs.name' | translate }}</label>
							<input class="form-control" type="text" name="name"
								[(ngModel)]="cost.name"
								placeholder="{{ 'annexes.costs.name_placeholder' | translate }}"
								#name="ngModel"
								[rangeLength]="[2, 256]"
								required
								autofocus/>
							<p class="validation-error" *ngIf="name.errors?.required && (name?.dirty && name?.touched)">{{ 'form.validate.required' | translate }}</p>
							<p class="validation-error" *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">{{ 'form.validate.minLenght' | translate }} 2!</p>
							<p class="validation-error" *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">{{ 'form.validate.maxLenght' | translate }} 256!</p>
						</div>
						<div class="col-lg-4 col-md-12 mb-3 mb-lg-0">
							<label class="input-label field-required">{{ 'annexes.costs.type' | translate }}</label>
							<select [(ngModel)]="cost.costType" (ngModelChange)="costTypeChangedEvent($event)"
								name="costType"
				 				#costType="ngModel"
								class="form-control ng-pristine ng-invalid ng-invalid-required ng-touched"
								required>
								<option value="FIX" class="ng-binding">{{ 'Fixed' | translate }}</option>
								<option value="FORMULA" class="ng-binding">{{ 'Formula' | translate }}</option>
							</select>
							<p class="validation-error" *ngIf="costType.errors?.required && (costType?.dirty && costType?.touched)">
								{{ 'form.validate.required' | translate }}
							</p>
						</div>
					</div>
					<div  class="row fields-group">
						<div class="col-lg-4 col-md-12 mb-3 mb-lg-0">
							<label class="input-label field-required">{{ 'annexes.costs.currency' | translate }}</label>
							<select class="form-control"
								type="text"
								name="currency"
								[(ngModel)]="cost.currencyId"
								#currency="ngModel"
								required>
								<option *ngFor="let currency of currencies" value="{{ currency.id }}" >{{ currency.name }}</option>
							</select>
							<p class="validation-error" *ngIf="currency.errors?.required && (currency?.dirty && currency?.touched)">
								{{ 'form.validate.required' | translate }}
							</p>
						</div>
						<div class="col-lg-8 col-md-12 mb-3 mb-lg-0" *ngIf="isFixCost()">
							<label class="input-label field-required">{{ 'annexes.costs.value' | translate }}</label>
							<input class="form-control"
								type="text"
								name="value"
								[(ngModel)]="fixValue"
								#costValue="ngModel"
								[min]="0"
								required
								number/>
							<p class="validation-error" *ngIf="costValue.errors?.required && (costValue?.dirty && costValue?.touched)">
								{{ 'form.validate.required' | translate }}
							</p>
							<p class="validation-error" *ngIf="costValue.errors?.number && (costValue?.dirty && costValue?.touched)">
								{{ 'form.validate.number' | translate }}
							</p>
							<p class="validation-error" *ngIf="costValue.errors?.min && (costValue?.dirty && costValue?.touched)">
								{{ 'form.validate.min' | translate }} 0!
							</p>
						</div>
					</div>

					<cost-items *ngIf="cost && cost.id && isFormulaCost() && !costTypeChanged"
						[serviceId]="serviceId"
						[formulaCost]="formulaCost"
						[determinantMapById]="determinantMapById"
						(changeFormula)="changeFormula($event)"
						[costView]="costView"></cost-items>

					<div class="row fields-group"
						*ngIf="store.state.common.userLevels.pages && store.state.common.userLevels.pages.SideNavLevel >= 3">
						<div class="col-12">
							<label class="input-label">{{ 'annexes.costs.recipient_accounts' | translate }}</label>
							<table class="table table-striped table-bordered align-middle bg-white">
								<tbody>
									<tr class="table-bordered">
										<td><span><label class="input-label">{{ 'annexes.costs.recipient_provider' | translate }}</label></span></td>
										<td><span><label class="input-label">{{ 'annexes.costs.recipient_account' | translate }}</label></span></td>
										<td *ngIf="showSettlementColumn"><span><label class="input-label">{{ 'annexes.costs.recipient_settle' | translate }}</label></span></td>
										<td></td>
									</tr>
									<tr class="table-bordered" *ngFor="let row of recipientAccountRows; let i = index">
										<td>
											<select class="form-control" name="recipientProvider{{i}}"
												*ngIf="providersLoaded"
												[(ngModel)]="row.provider">
												<option value="">{{ 'annexes.costs.recipient_provider_choose' | translate }}</option>
												<option *ngFor="let provider of paymentProviders" [value]="provider.code">{{ provider.name }}</option>
												<option *ngIf="row.provider && !isKnownProvider(row.provider)" [value]="row.provider">{{ row.provider }}</option>
											</select>
											<input class="form-control" type="text" name="recipientProvider{{i}}"
												*ngIf="!providersLoaded"
												[(ngModel)]="row.provider"
												placeholder="e.g. pesaflow"/>
										</td>
										<td>
											<input class="form-control" type="text" name="recipientAccountId{{i}}"
												[(ngModel)]="row.accountId"
												maxlength="64"/>
										</td>
										<td class="text-center fit-cell" *ngIf="showSettlementColumn">
											<input type="checkbox" name="recipientSettle{{i}}"
												[(ngModel)]="row.requireSettlement"/>
										</td>
										<td class="text-center fit-cell">
											<confirmation [showTrashIcon]="true"
												[question]="'confirm.areyousure'"
												(isConfirmed)="$event && removeRecipientAccountRow(i)">
											</confirmation>
										</td>
									</tr>
								</tbody>
								<tfoot>
									<tr class="table-bordered">
										<td [attr.colspan]="showSettlementColumn ? 4 : 3" class="text-center fit-cell">
											<button class="addBtn services-icon--add" type="button"
												(click)="addRecipientAccountRow()">{{ 'general.add' | translate }}</button>
										</td>
									</tr>
								</tfoot>
							</table>
							<p class="validation-error" *ngIf="incompleteRecipientAccountRows() > 0">
								{{ 'annexes.costs.recipient_incomplete' | translate }}
							</p>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</drawer>